"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerminalCreate = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const ac_1 = require("@app/ac");
const queries_1 = require("@app/queries");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const use_plugin_1 = require("@app/util/hooks/use-plugin");
const _ui_1 = require("@ui");
const TerminalCreate = ({ workspaceId, currentTerminals, onClose, }) => {
    const localities = (0, react_redux_1.useSelector)(({ workspaces, workspaceId, }) => 
    // @ts-expect-error: Object is possibly 'undefined'.
    workspaces.find((ws) => ws.id === workspaceId).localities || []);
    const usedLocalities = currentTerminals.map((item) => item?.localityId);
    const availableLocalities = localities.filter((loc) => !usedLocalities.includes(loc.id));
    const [state, setState] = (0, react_1.useState)({
        locality: localities.length ? localities[0].id : null,
        pin: null,
        errorPin: false,
    });
    const dispatch = (0, react_redux_1.useDispatch)();
    const calendar = (0, store_1.useRootSelector)((state) => state.calendar);
    const { isPluginEnabled, togglePlugin } = (0, use_plugin_1.usePlugin)();
    const { mutation, loading } = (0, util_1.useMutate)(queries_1.TerminalsCreate, {
        variables: {
            workspace: workspaceId,
            data: {
                // @ts-expect-error Type 'null' is not assignable to type 'string'.
                pin: parseInt(state.pin),
                localityId: state.locality || undefined,
            },
        },
        onCompleted: async () => {
            // Creating a terminal means the workspace wants terminals, so make sure the
            // plugin is on - it can be off while the /backoffice/terminals page is reachable
            if (!isPluginEnabled('terminal')) {
                await togglePlugin('terminal', calendar);
            }
            onClose();
            dispatch((0, ac_1.setModal)(null));
        },
    });
    const locOptions = availableLocalities.map((loc) => ({
        label: react_1.default.createElement(_ui_1.Locality, { id: loc.id }),
        value: loc.id,
    }));
    locOptions.push({
        label: react_1.default.createElement(react_1.default.Fragment, null, (0, util_1.t)('DROPDOWN_NOT_SELECTED')),
        // @ts-expect-error Type 'null' is not assignable to type 'string'.
        value: null,
    });
    const updatePinError = (v = state.pin) => {
        const regex = /^[0-9]{6}$/;
        if (!regex.test((v || '').toString())) {
            setState({ ...state, errorPin: true, pin: v });
            return true;
        }
        else {
            setState({ ...state, errorPin: false, pin: v });
            return false;
        }
    };
    return (react_1.default.createElement(_ui_1.Modal, { size: _ui_1.Modal.SIZES.S, testid: 'terminal-create-modal', dataTour: 'terminals-modal', headerContent: react_1.default.createElement(_ui_1.Text, { text: (0, util_1.t)('ADD_TERMINAL'), type: _ui_1.Text.TYPES.BODY_LARGE, weight: _ui_1.Text.WEIGHTS.BOLD }), footerContent: react_1.default.createElement(_ui_1.Flex, { stretch: true },
            react_1.default.createElement(_ui_1.Button, { onClick: () => dispatch((0, ac_1.setModal)(null)), size: _ui_1.Button.SIZES.FULL, label: (0, util_1.t)('CLOSE') }),
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_6, type: _ui_1.Spacing.TYPES.HORIZONTAL }),
            react_1.default.createElement(_ui_1.Button, { onClick: async () => {
                    const hasError = await updatePinError();
                    if (!hasError) {
                        await mutation();
                    }
                    else {
                        util_1.notification.error({
                            code: null,
                            message: 'TERMINAL_INVALID_ADMIN_PIN_FORMAT',
                        });
                    }
                }, disabled: loading, style: _ui_1.Button.STYLES.CONTAINED, size: _ui_1.Button.SIZES.FULL, label: (0, util_1.t)('SAVE'), bold: false })) },
        react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16, type: _ui_1.Spacing.TYPES.BOTH },
            react_1.default.createElement(_ui_1.Dropdown, { label: (0, util_1.t)('LOCALITY'), type: _ui_1.Dropdown.TYPES.VARIABLE, size: _ui_1.Dropdown.SIZES.FULL_WIDTH, style: _ui_1.Dropdown.STYLES.LIGHT, onChange: ({ value }) => setState({ ...state, locality: value }), options: locOptions, value: locOptions.find((loc) => loc.value === state.locality), singleSelect: true, cb: undefined }),
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_8, type: _ui_1.Spacing.TYPES.VERTICAL }),
            react_1.default.createElement(_ui_1.Input, { label: (0, util_1.t)('PIN_INPUT_LABEL'), value: (0, maybe_unwrap_1.unwrapMaybe)(state.pin), size: _ui_1.Input.SIZES.FULL_WIDTH, type: _ui_1.Input.TYPES.NUMBER, onChange: (value) => {
                    updatePinError(value);
                }, hasError: state.errorPin, innerRef: undefined }))));
};
exports.TerminalCreate = TerminalCreate;
